import { useApiBase } from './api/useApiBase'

export interface SparklesResponse {
  sparkles: Record<string, number>
}

export interface TickerItem {
  text: string
  category: string
}

export interface TickerResponse {
  items: TickerItem[]
}

export function useSocialApi() {
  const { apiBase, authenticatedFetch } = useApiBase()

  const getSparkles = async () => {
    return authenticatedFetch<SparklesResponse>(
      `${apiBase}/api/v1/social/sparkles`,
      { method: 'GET' },
    )
  }

  const getTicker = async () => {
    return authenticatedFetch<TickerResponse>(
      `${apiBase}/api/v1/social/ticker`,
      { method: 'GET' },
    )
  }

  return { getSparkles, getTicker }
}
